import { MainLoader } from 'shared/ui/MainLoader';

import { ApplicationLoad, BanksLoad, ScoringLoad, SelectionLoad } from 'features/SlidesLoader/ui/Slides';

import { SLIDES_LOADER_CHANGE_PERIOD_MS, SLIDES_LOADER_START_INDEX, SLIDES_LOADER_VARIANTS_COUNT } from '../config';
import { useCyclicVariant } from '../lib/useCyclicVariant';

export const SlidesLoader = () => {
  const variant = useCyclicVariant(SLIDES_LOADER_VARIANTS_COUNT, {
    periodMs: SLIDES_LOADER_CHANGE_PERIOD_MS,
    startIndex: SLIDES_LOADER_START_INDEX,
  });

  const Component =
    {
      0: ApplicationLoad,
      1: ScoringLoad,
      2: SelectionLoad,
      3: BanksLoad,
    }[variant] || (() => null);

  return <MainLoader Component={Component} />;
};
